/**
 * Language selection with manual selection tracking
 */
export class LanguageSelect {
    private languageSelectors: NodeListOf<HTMLElement>;
    private languageSelects: NodeListOf<HTMLSelectElement>;

    constructor() {
        // Select ALL language selector containers (there may be multiple on the page)
        this.languageSelectors = document.querySelectorAll(
            "[data-language-selector]"
        );

        if (this.languageSelectors.length === 0) {
            return;
        }

        // Handle dropdown selects
        this.languageSelects = document.querySelectorAll(
            "[data-language-select]"
        );

        for (const select of this.languageSelects) {
            select.selectedIndex = 0;
            select.onchange = () => {
                const location = select.options[select.selectedIndex].value;
                if (location !== "undefined" && location !== "") {
                    this.setManualSelection();
                    // Small delay to ensure cookie is set before navigation
                    setTimeout(() => {
                        window.location.href = location;
                    }, 10);
                }
            };
        }

        // Handle direct links (for single-language countries)
        // Loop through ALL language selector containers
        for (const languageSelector of this.languageSelectors) {
            const languageLinks = languageSelector.querySelectorAll(
                'a[href^="/"]'
            );

            for (const link of languageLinks) {
                link.addEventListener('click', (e) => {
                    this.setManualSelection();
                    // Let the link navigate normally
                });
            }
        }
    }

    /**
     * Set manual selection flag in cookie and localStorage
     * This prevents GeoIP from auto-redirecting the user
     */
    private setManualSelection(): void {
        // Set manual_selection cookie (1 year expiration)
        const expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 1);

        const cookieParts = [
            'manual_selection=1',
            `expires=${expirationDate.toUTCString()}`,
            'path=/',
            'SameSite=Lax'
        ];

        // Only add Secure flag if using HTTPS
        if (window.location.protocol === 'https:') {
            cookieParts.push('Secure');
        }

        document.cookie = cookieParts.join('; ');

        // Also set localStorage as backup
        try {
            localStorage.setItem('vl_manual_selection', '1');
            localStorage.setItem('vl_manual_selection_date', new Date().toISOString());
        } catch (e) {
            // localStorage might be disabled, that's okay
        }

        // Optional: Dispatch custom event for analytics
        this.dispatchManualSelectionEvent();
    }

    /**
     * Dispatch custom event for tracking manual language selection
     */
    private dispatchManualSelectionEvent(): void {
        const event = new CustomEvent('languageManuallySelected', {
            detail: {
                timestamp: new Date().toISOString()
            }
        });

        window.dispatchEvent(event);
    }
}
